// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "body{margin:0;padding:0}.w_1920{width:10rem}.w_1200{width:6.25rem}.bg_white{background:#fff}.bg_gray{background:#f4f4f4}.content{width:100%;min-height:100vh;display:flex;flex-direction:column;align-items:center}.logo{width:.73438rem;height:.51042rem}.divier{height:.00521rem;background:#e3e3e3}.divier--2{height:.01042rem;background:#e3e3e3}input,textarea{outline:none}.pager{width:100%;display:flex;flex-direction:row;justify-content:center;margin-top:.20833rem}", ""]);
// Exports
module.exports = exports;
